import * as yup from 'yup';
import { uniq, uniqBy } from 'lodash';

export const yieldManagementKmSchema = yup.object({
  extraKmCategoryFactors: yup
    .array(
      yup.object({
        category: yup.string().required(),
        factor: yup.number().required(),
      }),
    )
    .test(
      'no-duplicate-category',
      'Every extra km category factor must have a different category',
      (steps) => (steps?.length ?? '') === uniqBy(steps, 'category').length,
    ),
  pricePerExtraKmSteps: yup
    .array(yup.number().min(0))
    .test(
      'no-duplicate-prices-per-extra-km',
      'Every price per extra km must be a different value',
      (price) => (price?.length ?? '') === uniq(price).length,
    ),
  inclusiveKms: yup
    .array(
      yup.object({
        pricePerExtraKmLte: yup.number().min(0).required().nullable(),
        kmFromDays: yup
          .array(
            yup.object({
              fromDay: yup.number().min(1).required(),
              kmInclusivePerDay: yup.number().min(0).required(),
            }),
          )
          .test(
            'no-duplicate-from-day',
            'Every from day item must have a different from day',
            (step) => (step?.length ?? '') === uniqBy(step, 'fromDay').length,
          ),
      }),
    )
    .test(
      'no-duplicate-to-price-per-extra-km',
      'Every inclusive km step must have a different "to price per extra km"',
      (step) => (step?.length ?? '') === uniqBy(step, 'pricePerExtraKmLte').length,
    )
    .test(
      'must-have-one-to-price-per-extra-km-equal-to-null',
      'There must be one empty (open ended) "to price per extra km"',
      (step) =>
        step?.some(({ pricePerExtraKmLte }) => {
          return pricePerExtraKmLte === null;
        }),
    ),
});
